import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import packagejson from "../../../package.json";
import { loginAsEmpleador, logout } from "../../redux/actions/auth";
import CloseSessionDialog from "../commons/dialog/CloseSessionDialog";
import SeleccionUsuarioForm from "./SeleccionUsuarioForm";

const initialValues = {
  empleador: null,
  nombreEmpleador: "",
  version: packagejson.version,
}

const SeleccionUsuarioFormContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const empleadores = useSelector((state) => state.auth?.empleadores?.data || []);
  const login = useSelector((state) => state.auth)
  const [openLogout, setOpenLogout] = useState();
  const handleSubmit = (values) => {
    dispatch(loginAsEmpleador(values)).then(() => {
      navigate("/");
    })
  }

  return (
    <>
      <SeleccionUsuarioForm
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        empleadores={empleadores}
        loading={login.loading}
        logout={() => { setOpenLogout(true) }}
      />
      <CloseSessionDialog
        open={openLogout}
        handleClose={() => setOpenLogout(false)}
        handleConfirm={() => dispatch(logout())}
      />
    </>

  )
}

export default SeleccionUsuarioFormContainer;